import { useStore } from "@/app/stores/store";
import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

export const Intercom = () => {
  const {
    userStore: { userSession, isLoggedIn },
  } = useStore();
  const intercom = useIntercom();
  const baseUrl = import.meta.env.VITE_ROOT_URL;

  useEffect(() => {
    console.log("Intercom Initializing");
    intercom.update({
      name: userSession?.displayName,
      email: userSession?.emailAddress,
      phone: userSession?.phone,
      created_at: userSession?.createdAt,
      "System Person ID": userSession?.syncUserID,
      "System Office ID": userSession?.syncOfficeID,
      "Base user link": `https://base.entegral.net/Settings/SaveUser/${userSession?.userId}`,
      "Base office link": `https://base.entegral.net/Settings/SaveOffice?ID=${userSession?.officeID}`,
      Product: "Base",
      "Base user role": userSession?.role,
      company: {
        id: userSession?.officeID,
        name: userSession?.officeName,
        website: userSession?.officeWebsite,
        created_at: userSession?.officeCreatedAt,
      },
      avatar: {
        type: "avatar",
        image_url: userSession?.profilePic,
      },
    });
  }, [userSession, isLoggedIn]);

  return <></>;
};
